import { lazyLoad } from 'utils/loadable';

export const PlacementTrackerPageLoadable = lazyLoad(
  () => import('./PlacementTrackerPage'),
  module => module.PlacementTrackerPage,
);
